module.exports = __webpack_public_path__ + "img/hgfskfz.567886cb.png";